import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { LeadService } from 'src/app/private/services/lead.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-delete-pipeline',
  standalone: true,
  imports: [CommonModule, SharedModule],
  templateUrl: './delete-pipeline.component.html',
  styleUrls: ['./delete-pipeline.component.scss']
})
export class DeletePipelineComponent {
  @Input() editPipelineData: any = null;
  @Output() closeDialog = new EventEmitter<void>();
  @Output() reload = new EventEmitter<void>();

  loading: boolean = false;

  constructor(
    private api: LeadService,
    private localStorage: LocalStorageService,
    private toast: ToastrService
  ) {}

  onDelete(): void {
    if (!this.editPipelineData?.id) {
      this.toast.error('Pipeline ID not found');
      return;
    }

    this.loading = true;

    this.api.deletePipeline({ id: this.editPipelineData.id }).subscribe(
      (response: any) => {
        this.loading = false;
        this.toast.success(response.message || 'Pipeline deleted successfully');
        this.reload.emit();
        this.onClose();
      },
      (error: any) => {
        this.loading = false;
        this.toast.error(error.error?.message || 'Failed to delete pipeline. Please try again later.');
      }
    );
  }

  onClose(): void {
    this.closeDialog.emit();
  }
}
